import { render, staticRenderFns } from "./ScoopRewards.vue?vue&type=template&id=320d9b98&scoped=true&"
import script from "./ScoopRewards.vue?vue&type=script&lang=js&"
export * from "./ScoopRewards.vue?vue&type=script&lang=js&"
import style0 from "./ScoopRewards.vue?vue&type=style&index=0&id=320d9b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d9b98",
  null
  
)

export default component.exports